import "firebase/functions";
import { functions } from "firebase";
import React, { Component } from "react";
import overlayFactory from "react-bootstrap-table2-overlay";
import { Row, Col, Button, Breadcrumb, BreadcrumbItem } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { capitaliseWord } from "helpers/util";
import moment from 'moment';

class AllBusinesses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isTableLoading: true,
      isUnauthorised: false,
      noDataIndicationText: "Loading...",
    }
  }

  async componentDidMount() {
    await this.getBusinesses();
  }

  async getBusinesses() {
    let allBusinesses;
    let businessesFunction = functions().httpsCallable('getBusinesses');
    try {
      allBusinesses = (await businessesFunction()).data;
      this.setState({
        data: allBusinesses,
        isTableLoading: false
      });
    } catch (error) {
      if (error.code === 'unauthenticated') {
        this.setState({
          isUnauthorised: true,
          noDataIndicationText: "The account you're signed in with is not authorised to access this page.",
        });
      }

      this.setState({
        noDataIndicationText: "Error occured getting business data. Contact developers",
      });
      console.log("Couldn't get the data " + error);
      return;
    }
  }

  editBusiness = (cell, row) => {
    return (
      <Button color="primary"
        onClick={() => this.props.history.push(
          {
            pathname: `/admin/businesses/${row.id}`,
            state: { businessName: row.name }
          }
        )}
        className="float-left btn-rounded">
        Edit business
      </Button>
    );
  }

  seeBusinessInfo = (cell, row) => {
    return (
      <a
        href={"https://business.bamboo.app/dashboard/" + row.id}
        target="_blank"
        rel="noopener noreferrer"
      >
        {cell}
      </a>
    );
  }

  disabledFormatter = (cell, row) => {
    const disabledStatus = capitaliseWord(row.disabled.toString());
    return (
      <p>
        {
          row.disabled
            ? <span className="red">{disabledStatus}</span>
            : <span className="green">{disabledStatus}</span>
        }
      </p>
    );
  }

  lastOrderedFormatter = (cell, row) => {
    if (row.latestOrderTimestamp) {
      const latestOrderMoment = moment(row.latestOrderTimestamp);

      const now = moment();
      const today = now.clone().startOf("day");
      const yesterday = now.clone().subtract(1, "day").startOf("day");

      if (latestOrderMoment.isSame(today, "day")) {
        return "Today";
      } else if (latestOrderMoment.isSame(yesterday, "day")) {
        return "Yesterday";
      } else {
        return latestOrderMoment.format("DD/MM/YYYY");
      }
    } else {
      return "N/A";
    }
  }

  render() {
    const columns = [{
      dataField: 'id',
      text: '#',
      hidden: true,
    }, {
      dataField: 'name',
      text: 'Name:',
      sort: true,
      formatter: this.seeBusinessInfo,
    }, {
      dataField: "disabled",
      text: 'Disabled:',
      formatter: this.disabledFormatter,
      sort: true,
    }, {
      dataField: "latestOrderTimestamp",
      text: 'Last ordered:',
      formatter: this.lastOrderedFormatter,
      sort: true,
    }, {
      dataField: "orders",
      text: '# orders:',
      sort: true,
    }, {
      dataField: "employees",
      text: '# employees:',
      sort: true,
    }, {
      dataField: 'credit',
      text: '',
      formatter: this.editBusiness,
    }];

    const defaultSorted = [{
      dataField: "latestOrderTimestamp",
      order: "desc",
    }];

    const breadcrumb = (
      <Breadcrumb className="themed-breadcrumb">
        {/* this is an anchor tag as admin is not within our react router */}
        <BreadcrumbItem><a href="/admin">Home</a></BreadcrumbItem>
        <BreadcrumbItem active>Businesses List</BreadcrumbItem>
      </Breadcrumb>
    );

    const header = (
      <Col sm={{ size: 4, offset: 4 }} className="mt-2 mb-4 text-center">
        <p><span className="branded-word settings-tagline">Businesses List</span></p>

        <div style={{ "margin": "0 auto", "display": "inline-block" }}>
          {breadcrumb}
        </div>
      </Col>
    );

    const businessTable = (
      <Col sm={{ size: 10, offset: 1 }} className="pl-0 pr-0">
        <BootstrapTable
          bootstrap4
          classes="table-borderless"
          keyField='indexer'
          data={this.state.data}
          columns={columns}
          striped hover bordered={false}
          defaultSorted={defaultSorted}
          noDataIndication={this.state.noDataIndicationText}
          loading={this.state.tableDataLoading}
          overlay={overlayFactory({ spinner: true, background: 'rgba(192,192,192,0.3)' })}
        />
      </Col>
    );

    const notAuthorisedUI = (
      <Col sm={{ size: 4, offset: 4 }} className="dashboard-panel business-signup-form enable-scroll">
        <h4>Error: Account not authorised</h4>
        <p>The account you're signed in with is not authorised to access this page. <a href="/admin">Click here</a> to sign in</p>
      </Col>
    );

    return (
      <Row>
        {header}

        {
          this.state.isUnauthorised
            ? notAuthorisedUI
            : businessTable
        }
      </Row >
    );
  }
}

export default AllBusinesses;